<template lang="pug">
div(class="bg-white")
    div(class="lg:container lg:py-12")
        template(v-if="$fetchState.pending || isLoading")
            SpinnerText(
                text="Loading"
                isDark
                class="h-[500px]"
            )

        //- If the checkout total is 0 then the cart has already been paid for
        template(v-else-if="checkoutData.summary.grandTotal === 0")
            div(class="text-center p-3 py-6")
                div(class="flex justify-center items-center bg-success rounded-full w-24 h-24 mx-auto")
                    img(
                        class="w-10 h-10"
                        src="@/assets/common/checkmarkThick.svg"
                        alt="checkmark"
                        loading="lazy"
                        width="40"
                        height="40"
                    )

                h1 Thank You for Your Payment
                p(class="mb-5") We've received your payment and are completing your order now.
                p(class="font-bold text-success-dark text-xl") You can now safely close this tab.

        template(v-else)
            div(class="grid grid-cols-1 lg:grid-cols-60-40 gap-4 lg:gap-x-12 lg:gap-y-6")
                div(class="lg:order-last")
                    Summary

                div(class="px-3 lg:p-0 lg:order-first lg:col-span-2")
                    Breadcrumbs

                div(class="px-3 lg:p-0")
                    NuxtChild

</template>

<script>
import SpinnerText from '@/components/spinnerText'
import Breadcrumbs from './_components/breadcrumbs'
import Summary from './_components/summary'

export default {
    name: 'Paylink',
    components: {
        SpinnerText,
        Breadcrumbs,
        Summary,
    },
    fetchOnServer: false,
    async beforeRouteLeave(to, from, next) {
        this.isLoading = true

        await this.$store.dispatch('cart/restoreOriginalCart', { refreshCart: false })

        await this.updateCartAndCheckout()

        next()

        this.$store.dispatch('setSimpleMode', false)
    },
    async asyncData({ store }) {
        // Set simple mode
        await store.dispatch('setSimpleMode', true)
    },
    data() {
        return {
            isLoading: false,
        }
    },
    async fetch() {
        this.$store.commit('setPermId', this.$route.params.id)

        await this.updateCartAndCheckout()

        if (this.$route.query.checkout_token)
            await this.processAffirmToken(this.$route.query.checkout_token)
    },
    computed: {
        checkoutData() {
            return this.$store.state.checkout.data
        },
    },
    methods: {
        updateCartAndCheckout() {
            return Promise.all([
                this.$store.dispatch('cart/getCart'),
                this.$store.dispatch('checkout/getCheckout'),
            ])
        },
        async processAffirmToken(checkoutToken) {
            try {
                this.isLoading = true
                await this.$affirm.placeOrder(checkoutToken)
            } catch (error) {
                this.isLoading = false
            }
        },
    },
}
</script>
